import configureStore from "../../phc-web/app/store";

const store = configureStore();

export const getEmbeddedStore = () => ({ ...store });
